var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7368 3.26313H1.26316C0.928829 3.26093 0.60882 3.12713 0.372409 2.89072C0.135998 2.65431 0.00220686 2.3343 0 1.99997C0.00220686 1.66565 0.135998 1.34564 0.372409 1.10923C0.60882 0.872814 0.928829 0.739023 1.26316 0.736816L14.7368 0.736816C15.0712 0.739023 15.3912 0.872814 15.6276 1.10923C15.864 1.34564 15.9978 1.66565 16 1.99997C15.9978 2.3343 15.864 2.65431 15.6276 2.89072C15.3912 3.12713 15.0712 3.26093 14.7368 3.26313Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.903f7e8be5c407a031f610e1a470ba8f.svg";
export { ForwardRef as ReactComponent };